var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"background"},[(!_vm.loading)?_c('router-view'):_vm._e()],1),_c('AlertBar',{ref:"alertBar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }